const accordionData = () => {
  jQuery('.accordion-link').on('click', function (e) {
    e.preventDefault();
    let accordionTarget;
    if (jQuery(this).data('accordion-toggle')) {
      accordionTarget = jQuery(this).data('accordion-toggle');
      const accordionToggle = jQuery("*[data-accordion-toggle='" + accordionTarget + "']");
      accordionToggle.toggleClass('accordion-link-opened');
      accordionToggle.attr('aria-expanded') === 'true'
        ? accordionToggle.attr('aria-expanded', 'false')
        : accordionToggle.attr('aria-expanded', 'true');
      jQuery("*[data-accordion-target='" + accordionTarget + "']").slideToggle();
    } else {
      accordionTarget = jQuery(this).data('accordion-link');
      jQuery("*[data-accordion-link='" + accordionTarget + "'], *[data-accordion-toggle='" + accordionTarget + "']").addClass('accordion-link-opened');
      jQuery("*[data-accordion-target='" + accordionTarget + "']").slideDown();
    }
  });
};
export { accordionData };
